import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{aboutData.title}</h2>
            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">{aboutData.content}</p>
            <a href="#contact" className="inline-flex items-center gap-1.5 mt-5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              了解更多 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex-shrink-0 w-full lg:w-auto">
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              {aboutData.stats.map((s, i) => (
                <div
                  key={i}
                  className={`text-center p-4 md:p-6 rounded-lg ${
                    i === 0 ? 'bg-primary-100' : i === 1 ? 'bg-accent-100' : i === 2 ? 'bg-secondary-100' : 'bg-background-100'
                  }`}
                >
                  <div className={`text-xl md:text-2xl font-heading font-bold ${
                    i === 0 ? 'text-primary-700' : i === 1 ? 'text-accent-700' : i === 2 ? 'text-secondary-700' : 'text-foreground-700'
                  }`}>
                    {s.value}
                  </div>
                  <div className="mt-1 text-xs text-foreground-500 whitespace-nowrap">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}